import Model from "../Model";

export default class Stats extends Model {
    public billNotPayed!: number;//Montant non payés
    public billed!: number;//Montant facturés
    public billedVat!: number;//TVA mis dans les factures
    public uploadPayin!: number;//
    public uploadPayinVat!: number;//
    public uploadPayinNotPayed!: number;//
    public uploadPayout!: number;//Dépenses
    public uploadPayoutNotPayed!: number;
    public uploadPayoutVat!: number;
    public invoiceCount: any;

    get billedWithoutVat(): number {
        return this.billed - this.billedVat;
    }

    get uploadPayoutWithoutVat(): number {
        return this.uploadPayout - this.uploadPayoutVat;
    }

    get treasury(): number {
        return (this.billed - this.billedVat) - (this.uploadPayout - this.uploadPayoutVat)
    }

    constructor(obj: any = {}) {
        super();
        if (typeof obj === 'string') {
            obj = JSON.parse(obj);
        }
        Stats.buildFromJson(this, obj);
    }

    /**
     * builds the class instance from a javascript object
     * @param instance this
     * @param json javascript object
     */
    private static buildFromJson(instance: any, json: any) {
        if (json) {
            for (let prop in json) {
                if (json.hasOwnProperty(prop)) {
                    instance[prop] = json[prop];
                }
            }
        }
    }

    exportToJson() {
    }
}